import * as actions from './saleTag/actions'
import * as mutations from './saleTag/mutations'
import * as getters from './saleTag/getters'

import { dataProps } from './saleTag/properties'

const state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/saleTag.js